import toast from "react-hot-toast";
import handlePaymentSuccess from "./handlePaymentSuccess";
import SDK from "../../config";
import axios from "axios";

export const handleSubmit = async (
  event,
  stripe,
  elements,
  email,
  // phone,
  // zipcode,
  CardNumberElement,
  cardName,
  setPageLoader,
  navigate
) => {
  event.preventDefault();
  const type = "gift";

  if (!stripe || !elements) {
    return;
  }

  const tagsString = SDK.mailchimpPriceTag;
  const queryParams = new URLSearchParams({
    email_address: email,
    status: "subscribed",
    tags: tagsString,
    type,
    AddToCart: "1",
  });

  const queryString = queryParams.toString();
  axios
    .post(`${SDK.BASE_URL}/api/post_email_smashsend?${queryString}`)
    .then((response) => {})
    .catch((error) => {
      console.error("Error saving email:", error);
    });

  const paymentOf = "iOS";
  
  const cardNumberElement = elements.getElement(CardNumberElement);

  if (!cardNumberElement) {
    console.error("CardNumberElement not found");
    return;
  }

  setPageLoader(true);

  try {
    const saveRegion = localStorage.getItem("region") || "us";
    const { currency } =
      SDK.REGION_CONFIG[saveRegion] || SDK.REGION_CONFIG["us"];
    const response = await fetch(`${SDK.BASE_URL}/api/create-payment-intent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        // phone,
        // zipcode,
        paymentOf,
        regionCur: currency,
        type,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error creating payment intent:", errorData.error);
      toast.error("Failed to create payment intent.");
      setPageLoader(false);
      return;
    }

    const data = await response.json();
    const clientSecret = data.clientSecret;

    // Confirm Payment
    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardNumberElement,
        billing_details: {
          name: cardName,
        },
      },
    });

    if (result.error) {
      console.error("Payment failed:", result.error.message);
      toast.error("Invalid Card Details");
    } else {
      if (result.paymentIntent.status === "succeeded") {
        const methodType = "Debit Card";
        const paymentWay = "iOS";
        await handlePaymentSuccess(
          result.paymentIntent,
          methodType,
          cardName,
          email,
          // phone,
          // zipcode,
          paymentWay
        );

        await fetch(`${SDK.BASE_URL}/api/save-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        });

        navigate(`/confirmation?email=${encodeURIComponent(email)}`);
        toast.success("Payment Successful");

        // Clear local storage
        localStorage.removeItem("email");
        // localStorage.removeItem("phone");
        // localStorage.removeItem("zipcode");
      }
    }
  } catch (error) {
    console.error("Error processing payment:", error);
    toast.error("Payment failed. Please try again.");
  } finally {
    setPageLoader(false);
  }
};
